<template>
  <div class="morghing">
    <div class="morghing__title-wrapper" :style="{ '--hero-title-scale': heroTitleScale }">
      <img src="/main_hero_banner_cube.webp" alt="" aria-hidden="true">

      <h1 class="morghing__title" :class="{ dark: userTheme === 'dark-theme' }">
        <span>
          LIFE SCIENCE
        </span>
        <span>
          Digital Excellence
        </span>
        <span>
          PARTNER
        </span>
      </h1>
    </div>
    <img class="morghing__gradient" src="/main_hero_banner_double_gradient.svg" alt="" aria-hidden="true">
    <img class="morghing__gradient morghing__gradient--bottom" src="/main_hero_banner_gradient.svg" alt="" aria-hidden="true">

    <div class="arrow-rapper">
      <div @click="scrollToTheNextSection" class="arrow-block cursor-hover">
        <svg viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M70.8086 38.8096L44.8181 64.8001L20.4727 40.4546" stroke="#354F57" stroke-width="2"/>
          <path d="M44.8184 64.7957V0.817383" stroke="#354F57" stroke-width="2"/>
        </svg>
      </div>
    </div>

  </div>
</template>

<script setup>
  import {
    computed,
    onBeforeUnmount,
    onMounted,
    ref
  } from 'vue';
  import { useStore } from 'vuex';

  const store = useStore();

  const windowWidth = ref(window.innerWidth);

  const userTheme = computed(() => store.getters.getUserTheme);
  const heroTitleScale = computed(() => Math.max(0.3, Math.min(1, windowWidth.value / 1440)));

  onMounted(() => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    window.addEventListener('resize', handleResize);
    document.querySelector('.morghing')?.addEventListener('wheel', handleScroll);
  });

  function scrollToTheNextSection() {
    document.querySelector('#why-section')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  function handleResize() {
    windowWidth.value = window.innerWidth;
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  function handleScroll(e) {
    if (e.deltaY > 0) {
      setTimeout(() => {
        scrollToTheNextSection();
      }, 50);
    }
  }

  onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize);
    document.querySelector('.morghing')?.removeEventListener('wheel', handleScroll);
  });
</script>

<style lang="scss" scoped>
.morghing {
  background-color: var(--background-color-primary);
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  margin-top: 74px;

  min-height: calc((var(--vh, 1vh) * 100) - 74px);

  @media screen and (max-width: 768px) {
    min-height: calc((var(--vh, 1vh) * 100) - 68px);
  }

  @media screen and (max-width: 660px) {
    min-height: calc((var(--vh, 1vh) * 100) - 56px);
  }

  @media screen and (max-width: 768px) {
    margin-top: 68px;
  }
  @media screen and (max-width: 660px) {
    margin-top: 56px;
  }

  &__title-wrapper {
    position: relative;
    z-index: 1;
    transform: scale(var(--hero-title-scale));
    transform-origin: center;

    img {
      position: absolute;
      inset-block-start: -430px;
      inset-inline-end: -380px;
      transform: scale(.8);

      @media screen and (max-width: 768px) {
        inset-block-start: -630px;
        inset-inline-end: -350px;
      }
    }
  }

  &__title {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
    color: #354F57;
    font-size: 88px;
    line-height: 1;
    font-weight: 300;
    text-align: start;
    transform: translateX(-20%);
    white-space: nowrap;

    @media screen and (max-width: 768px) {
      transform: translateX(0);
    }

    span:nth-child(2) {
      font-family: 'Times New Roman';
      color: #000;
      font-style: italic;
      font-size: 108px;
      font-weight: 400;

      @media screen and (max-width: 768px) {
        font-size: 125px;
      }
    }

    span:nth-child(3) {
      text-align: end;
    }

    &.dark {
      color: #D4DADF;

      span:nth-child(2) {
        color: #FFF;
      }
    }
  }

  .arrow-rapper {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 2;

    height: 100vh;
    height: calc((var(--vh, 1vh) * 100) - 74px);

    @media screen and (max-width: 768px) {
      height: calc((var(--vh, 1vh) * 100) - 68px);
    }

    @media screen and (max-width: 660px) {
      height: calc((var(--vh, 1vh) * 100) - 56px);
    }
  }

  .arrow-block {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 36px;
    margin: 0 auto;
    max-width: 60px;
    width: 100%;
    height: auto;
    display: block;

    svg {
      display: block;
      max-width: 100%;
      height: auto;
    }

    @media screen and (max-width: 1024px) {
      max-width: 50px;
      bottom: 20px;
    }

    @media screen and (max-width: 600px) {
      max-width: 40px;
      bottom: 10px;
    }

    path {
      stroke: var(--text-secondary-color);
    }
  }

  &__gradient {
    position: absolute;
    top: 0;
    left: 0;
    transform: translateY(-35%) translateX(-35%);
    width: 1000px;
    min-width: 700px;
    height: auto;
    z-index: 0;
    pointer-events: none;

    &--bottom {
      top: auto;
      left: auto;
      right: 0;
      bottom: 0;
      transform: translateX(15%) translateY(25%);

      @media screen and (max-width: 768px) {
        transform: translateX(35%) translateY(35%);
      }

    }
  }
}
</style>
